const radius = 'radius';
export const aliasRadiusBuiltIns = {
    borderRadius: radius,
    borderTopLeftRadius: radius,
    borderTopRightRadius: radius,
    borderBottomRightRadius: radius,
    borderBottomLeftRadius: radius
};
export const aliasRadius = {
    ...aliasRadiusBuiltIns
};

//# sourceMappingURL=aliasRadius.js.map